import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import { CirculationArea } from 'shell/models/circulation-area';
import { HttpResponse } from 'shell/models/http-response';
import { transformExponent } from 'system/components/shared/street-number-list/transform-exponent';
import { CirculationAreaForm } from 'system/components/toponymy/form';
import { FlagCirculationArea } from 'system/constants/circulation-area-flag';

export const transformResponseCirculationArea = (
  response: AxiosResponse<HttpResponse<CirculationArea>>,
  civic: string,
  exponent: string
): CirculationAreaForm => {
  const circulationArea = response.data.payload || {};

  return {
    descriptionReducedPostal: circulationArea.descrizionePostaleRidotta,
    descriptionReduced: circulationArea.descrizioneRidotta,
    code: circulationArea.key?.codice.toString() || '',
    name: circulationArea.descrizionePostale || '',
    type: circulationArea.tipoArea || '',
    terminate: circulationArea.flag === FlagCirculationArea.End,
    deliberated: circulationArea.flag === FlagCirculationArea.NotDeliberated,
    typeDeliberated: circulationArea.tipoDelibera,
    estabilishmentDate: circulationArea.dataIstituzione
      ? DateTime.fromISO(circulationArea.dataIstituzione)
      : null,
    endDate: circulationArea.dataCessazione
      ? DateTime.fromISO(circulationArea.dataCessazione)
      : null,
    officeNumber: circulationArea.lunghezza || 0,
    electoralSection: '',
    civic: '',
    endReason: '',
    civicState: '',
    municipality: '',
    entered: false,
    estabilishmentReason: '',
    temporary: false,
    streetEnd: false,
    cap: '',
    keyFromData: circulationArea.key,
    streetNumber: civic
      ? {
          id: Number.parseInt(civic, 10),
          value: `${civic}${transformExponent(exponent)}`,
          esponente: exponent,
        }
      : undefined,
    urbanArea: '',
    civicType: '',
    addressSection: '',
    territorialArea: '',
    municipalMessenger: null,
    censusSection: '',
    localIdentity: '',
    cadastralList: [],
  };
};
